import Link from "next/link";
import Img from "react-cloudimage-responsive";

interface SectionBlogProps {
  Title?: string;
  Image?: string;
  Ref?: string;
  DisplayCreatedAt?: string;
  Desc?: string;
  Key?: number;
}

export default function SectionBlog(props: SectionBlogProps) {
  return (
    <>
      <Link href={`/blogs/content/${props.Title}/${props.Ref}`} key={props.Key}>
        <div className="col-12 col-md-6 col-lg-4 grid">
          <div
            className="card"
            style={{
              borderRadius: 20,
            }}
          >
            <Img
              className="border-radius"
              ratio={2 / 1}
              src={props.Image ?? "default-blog-img.png"}
              alt={props.Title}
            ></Img>
            <div className="blog-card-img-overlay">
              <div
                className="card-footer blog-card-background"
                style={{
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10,
                }}
              >
                <h4
                  style={{
                    float: "left",
                    fontSize: 12,
                    color: "#ffffff",
                  }}
                >
                  {props.Title}
                </h4>
                <h4
                  style={{
                    float: "right",
                    fontSize: 12,
                    color: "#ffffff",
                  }}
                >
                  {props.DisplayCreatedAt}
                </h4>
                <div style={{ clear: "both" }}></div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#ffffff",
                    opacity: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  {props.Desc}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}
